import React, {useEffect, useState} from 'react';
import './Account.css';
import Navigation from '../../components/Navigation/Navigation';
import AccountInfo from '../../components/AccountInfo/AccountInfo';
import Accounts from '../../components/Accounts/Accounts';
import SuccessModal from '../../components/SuccessModal/SuccessModal';
import DeleteModal from '../../components/DeleteModal/DeleteModal';
import * as Styles from './AccountStyles';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import ErrorModal from '../../components/ErrorModal/ErrorModal';
import useObservable from '../../hooks/useObservable';
import SubscriptionsStore from '../../xstores/subscriptions';
import * as Styled from '../../components/SearchInput/SearchInputStyles';
import warningIcon from '../../../images/warning-icon.svg';
import PromptModal from '../../components/PromptModal/PromptModal';
import {Box, Image} from '../../styled';
import puzzlePieces from '../../../images/puzzle-pieces.svg';

const Account = () => {
  const [pageError, setPageError] = useState<any>(null);
  const [promptOpen, setPromptOpen] = useState(false);
  const loadingSubscriptions = useObservable(SubscriptionsStore.loading$, false);
  const connectionLinks = useObservable(SubscriptionsStore.connectionLinks$, []);
  const subscriptions = useObservable(SubscriptionsStore.current$, []);
  const normalizedSubscriptions = useObservable(SubscriptionsStore.normalized$, {});

  const onErrorDismiss = () => {
    setPageError(null);
  }
  const closePrompt = () => {
    setPromptOpen(false);
  }

  useEffect(() => {
    SubscriptionsStore.getConnectionLinks();
  }, []);

  useEffect(() => {
    if (loadingSubscriptions) {
      return;
    }
    setPromptOpen(subscriptions.length ? false: true);
  }, [subscriptions, loadingSubscriptions])

  return (
    <Styles.Container>
      <Navigation />
      <ErrorBoundary>
        <AccountInfo />
        {
          loadingSubscriptions ?
            <Styles.StyledH2>Loading...</Styles.StyledH2>
            :
            <Accounts
              isLoading={loadingSubscriptions}
              subscriptions={normalizedSubscriptions}
              connectionLinks={connectionLinks}
            />
        }
        <SuccessModal />
        <DeleteModal />
      </ErrorBoundary>
      <ErrorModal error={pageError} onDismiss={onErrorDismiss} />
      <PromptModal
        open={promptOpen}
        message={(
          <>
            <Box display={'flex'} justifyContent={'center'} mb={4}>
              <Image src={puzzlePieces} />
            </Box>
            <Styled.StyledParagraph>
              To begin with Trova, connect your apps and search content across your workspace(s).
            </Styled.StyledParagraph>
            <img src={warningIcon} alt="Warning"/>
            <Styled.StyledSpan>
              All of your data is encrypted.
            </Styled.StyledSpan>
          </>
        )}
        onClose={closePrompt}
        buttonTxt="Got it"
      />
    </Styles.Container>
  );
}

export default Account;